import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { checkAndRedirect } from '../utils/redirect';

/**
 * Component that handles automatic redirect from foundersmate.ai to app.foundersmate.ai
 * This should be added to the App component to check on every route change
 */
const RedirectHandler: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if we should redirect based on hostname
    checkAndRedirect();
  }, [location]);

  return null; // This component doesn't render anything
};

export default RedirectHandler;
